/* eslint-disable formatjs/no-literal-string-in-jsx */

import React, { FunctionComponent } from 'react'
import { Field, Form } from 'react-final-form'
import { View } from 'react-native'

import styled, { useTheme } from 'styled-components/native'

import { isValidInteger } from '@lyrahealth-inc/shared-app-logic'

import { BodyText, Button, ButtonTypes, InputFieldRFF } from '../../../atoms'
import { getFontStyles } from '../../../styles'
import { tID } from '../../../utils'

const ButtonContainer = styled.View`
  padding: 20px 0px;
`

const Container = styled.View`
  flex-direction: row;
  margin-bottom: 5px;
`

export const AuthForm: FunctionComponent<AuthFormProps> = ({ onSubmit, idTokenExpiration, inactivityExpiration }) => {
  const { colors: themeColors, fontFamilyMetadata } = useTheme()
  const textColor = getFontStyles(themeColors, fontFamilyMetadata).body.default
  const timeoutValidation = ({
    idTokenExpiration,
    inactivityExpiration,
  }: {
    idTokenExpiration: string
    inactivityExpiration: string
  }) => {
    const errors = {} as Dict
    if (!idTokenExpiration || !isValidInteger(idTokenExpiration)) {
      errors.idTokenExpiration = 'Invalid App Timeout'
    }
    if (!inactivityExpiration || !isValidInteger(inactivityExpiration)) {
      errors.inactivityExpiration = 'Invalid Inactivity Timeout'
    }
    return errors
  }
  return (
    <Form
      initialValues={{ idTokenExpiration, inactivityExpiration }}
      onSubmit={onSubmit}
      validate={timeoutValidation}
      render={({ handleSubmit }) => (
        <View testID={tID('AuthForm')}>
          <Container>
            <BodyText text='Set ID Token Expiration to simulate JWT expiring to refresh tokens' wrap />
          </Container>
          <Container>
            <BodyText text='Current ID Token Timeout MS: ' />
            <BodyText text={idTokenExpiration} />
          </Container>
          <Field component={InputFieldRFF} name='idTokenExpiration' typeStyle={textColor} />
          <Container>
            <BodyText text='Set Inactivity Timeout to simulate user inactivity and logout user' wrap />
          </Container>
          <Container>
            <BodyText text='Current Inactivity Timeout MS: ' />
            <BodyText text={inactivityExpiration} />
          </Container>
          <Field component={InputFieldRFF} name='inactivityExpiration' typeStyle={textColor} />
          <ButtonContainer>
            <Button
              title='Save Timeout'
              onPress={() => {
                handleSubmit()
              }}
              buttonType={ButtonTypes.DEV}
            />
          </ButtonContainer>
        </View>
      )}
    />
  )
}

type AuthFormProps = {
  idTokenExpiration: string
  inactivityExpiration: string
  onSubmit: (value: Dict) => void
}
